namespace TabAurous.Retail {
    export interface ReceiptDenominationDetailsForm {
        DenominationId: Serenity.IntegerEditor;
        Count: Serenity.IntegerEditor;
        Amount: Serenity.DecimalEditor;
    }

    export class ReceiptDenominationDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.ReceiptDenominationDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptDenominationDetailsForm.init)  {
                ReceiptDenominationDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(ReceiptDenominationDetailsForm, [
                    'DenominationId', w0,
                    'Count', w0,
                    'Amount', w1
                ]);
            }
        }
    }
}
